import { Box, Container, Grid, Typography, Paper, Card, CardActionArea, CardMedia, CardContent, useTheme, useMediaQuery, } from '@mui/material';
import React, { useCallback, useRef,} from "react";

import "@fontsource/noto-sans-thai";
import { IconButton } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosNewIcon from '@mui/icons-material/ArrowForwardIos';


import 'react-responsive-carousel/lib/styles/carousel.min.css'; // Import the styles
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from 'embla-carousel-autoplay';

import { importAll } from '../utils/loadImages';

import Copyright from "../components/CopyRights";
import Banner1 from '../assets/Banner1.jpg';
import Banner2 from '../assets/Banner2.jpg';
import aboutBG from '../assets/about_BG2.jpg'; //bg

import Card1 from '../assets/Card1.jpg';
import Card2 from '../assets/Card2.jpg';
import Card3 from '../assets/Card3.jpg';
import Card4 from '../assets/Card4_3.jpg';
import Card5 from '../assets/Card5_2.jpg';
import Card6 from '../assets/Card6.jpg';

import NP_Card1 from '../assets/NewProducts/new_products (1).jpg'
import NP_Card2 from '../assets/NewProducts/new_products (2).jpg'
import NP_Card3 from '../assets/NewProducts/new_products (3).jpg'
import NP_Card4 from '../assets/NewProducts/new_products (4).jpg'
import NP_Card5 from '../assets/NewProducts/new_products (5).jpg'
import NP_Card6 from '../assets/NewProducts/new_products (6).jpg'
import NP_Card7 from '../assets/NewProducts/new_products (7).jpg'
import NP_Card8 from '../assets/NewProducts/new_products (8).jpg'
import FacebookFeed from '../components/FacebookFeed';
import LocationMap from '../components/LocationMap';

import FaxIcon from '@mui/icons-material/Fax';
import PhonelinkRingIcon from '@mui/icons-material/PhonelinkRing';
import PhoneIcon from '@mui/icons-material/Phone';
import SocialButtons from '../components/SocialButtons';
import HomeContact from '../components/homeComponents/homeContact';


const Home = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  //Main Banner Images
  const CarouselImages = [
    Banner1, Banner2,
  ];
  //Brand Images
  const BrandImages = importAll(require.context('../assets/Logos', false, /\.(png|jpe?g|svg)$/));

  // ===================== EMBLA CAROUSEL HOOK =====================

  //Carousel 1
  const [emblaRef1, embla] = useEmblaCarousel({
    loop: true,
    skipSnaps: false,
    draggable: false, // disables touch/swipe
  });
  //Carousel 1 Scroll
  const scrollPrev = useCallback(() => embla && embla.scrollPrev(), [embla]);
  const scrollNext = useCallback(() => embla && embla.scrollNext(), [embla]);

  
  // ===================== CAROUSEL 2 (BRANDS) =====================
const autoplay1 = useRef(
  Autoplay({
    delay: 3000,
    stopOnInteraction: false,
    stopOnMouseEnter: false,
  })
)

const [emblaRef2] = useEmblaCarousel(
  {
    loop: true,
    align: "center",
    slidesToScroll: 1,
  },
  [autoplay1.current]
)

// ===================== CAROUSEL 3 (NEW PRODUCTS) =====================
const autoplay2 = useRef(
  Autoplay({
    delay: 3000,
    stopOnInteraction: false,
    stopOnMouseEnter: false,
  })
)

const [emblaRef3] = useEmblaCarousel(
  {
    loop: true,
    align: "center",
    slidesToScroll: 1,
  },
  [autoplay2.current]
)

  return (
    <Grid container component="main" 
            sx={{ 
                 
                paddingTop: '55px', 
                position: 'relative',
                
                backgroundAttachment: 'fixed',
                backgroundImage: `url(${aboutBG})`,
                //backgroundRepeat: 'repeat',
                //backgroundSize: isMobile ? '100%' : '33%',
                backgroundSize: 'cover',
                //backgroundPosition: 'center',
                
            }}
        >
    <Container >
      <Grid container component="main" 
              sx={{ 
                paddingTop: '40px',
                paddingBottom: '10px',
              }}
        >
          <Box 
            position="relative" 
            overflow="hidden"
            sx={{
              boxShadow: 3, // MUI's theme-based elevation
              border: '1px solid #e0e0e0', // light gray border
              borderRadius: '16px', // match image
            }}
            >
            {/* Arrows */}
            <IconButton
              onClick={scrollPrev}
              sx={{
                position: "absolute",
                left: 15,
                top: "50%",
                transform: "translateY(-50%)",
                zIndex: 2,
                color: "black",
                backgroundColor: "rgba(255,255,255,0.7)",
              }}
            >
              <ArrowBackIosNewIcon/>
            </IconButton>

            <IconButton
              onClick={scrollNext}
              sx={{
                position: "absolute",
                right: 15,
                top: "50%",
                transform: "translateY(-50%)",
                zIndex: 2,
                color: "black",
                backgroundColor: "rgba(255,255,255,0.7)",
              }}
            >
              <ArrowForwardIosNewIcon />
            </IconButton>

            {/* Carousel */}
            <Box ref={emblaRef1} className="embla">
              <Box
                className="embla__container"
                display="flex"
                gap={2}
                
              >
                {CarouselImages.map((image, index) => (
                  <Box
                    className="embla__slide"
                    key={index}
                    sx={{ flex: `0 0 ${isMobile ? "100%" : "100%"}`, }}
                  >
                    <Card
                        sx={{
                        display: "flex",
                        justifyContent: "center",
                        
                      }}
                    >
                      <CardMedia
                        component="img"
                        image={image}
                        alt={`Slide ${index}`}
                        sx={{ width: "100%", objectFit: "cover", borderRadius: "16px" }}
                      />
                    </Card>
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>
        </Grid> 
      <Paper align='center' elevation={5} sx={{  padding: 4 , borderRadius: "16px"}} container spacing={2}>
      <Typography
        component="h1"
        variant="h3"
        sx={{ mt: 2, fontWeight: "bold" }}
      >
        สินค้ามาใหม่
      </Typography>

      <Box
        position="relative"
        sx={{
          overflow: "hidden",
          width: "100%",
          mt: 3,
        }}
      >
        {/* Fade Left */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "60px",
            height: "100%",
            zIndex: 2,
            background: "linear-gradient(to right, white, transparent)",
            pointerEvents: "none",
          }}
        />

        {/* Fade Right */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            right: 0,
            width: "60px",
            height: "100%",
            zIndex: 2,
            background: "linear-gradient(to left, white, transparent)",
            pointerEvents: "none",
          }}
        />

        {/* Carousel */}
        <Box
          ref={emblaRef3}
          className="embla"
          sx={{
            overflow: "hidden",
            width: "100%",
          }}
        >
          <Box
            className="embla__container"
            sx={{
              display: "flex",
              gap: 3,
              px: 3,
            }}
          >
            {[
              NP_Card1,
              NP_Card2,
              NP_Card3,
              NP_Card4,
              NP_Card5,
              NP_Card6,
              NP_Card7,
              NP_Card8,
            ].map((image, index) => (
              <Box
                className="embla__slide"
                key={index}
                sx={{
                  flex: `0 0 ${isMobile ? "85%" : "30%"}`,
                }}
              >
                <Card
                  elevation={3}
                  sx={{
                    borderRadius: "16px",
                    maxWidth: 340,
                  }}
                >
                  <CardActionArea>
                    <CardMedia
                      component="img"
                      image={image}
                      alt={`new-product-${index}`}
                      sx={{
                        borderRadius: "16px",
                      }}
                    />
                  </CardActionArea>
                </Card>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>

      <HomeContact/>
            

      <Typography
          component="h1"
          variant="h4"
          paddingTop={'15px'}
          sx={{ mt: 4, fontWeight: 'bold' }}
        >
          บริการของเรา
        </Typography>

        <Grid container spacing={3.5} sx={{ mt: 1 }}>

          {/* LEFT SIDE */}
          <Grid item xs={12} md={8}>
            <Grid container spacing={3.5} justifyContent="center">

              <Grid item>
                <Card elevation={3} sx={{ maxWidth: 340, height: '100%', borderRadius: "16px" }}>
                  <CardActionArea>
                    <CardMedia
                      component="img"
                      height="250"
                      image={Card5}
                      alt="Bags"
                    />
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="div">
                        ผลิตและนำเข้ากระเป๋าทุกประเภท
                      </Typography>
                      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                        รับผลิตและนำเข้ากระเป๋าทุกชนิด ทั้งกระเป๋าผ้า เป้ และกระเป๋าเดินทาง ด้วยคุณภาพและดีไซน์ที่ตอบโจทย์ทุกความต้องการ
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>

              <Grid item>
                <Card elevation={3} sx={{ maxWidth: 340, height: '100%', borderRadius: "16px" }}>
                  <CardActionArea>
                    <CardMedia
                      component="img"
                      height="250"
                      image={Card4}
                      alt="Uniform"
                    />
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="div">
                        ผลิตและออกแบบเสื้อผ้า
                      </Typography>
                      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                        บริการรับผลิตยูนิฟอร์ม เสื้อโปโล เสื้อยืด เสื้อแจ็คเก็ต และหมวกนานาชนิด ตามแบบที่คุณต้องการ ด้วยคุณภาพและความใส่ใจในทุกขั้นตอน
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>

              <Grid item>
                <Card elevation={3} sx={{ maxWidth: 340, height: '100%', borderRadius: "16px" }}>
                  <CardActionArea>
                    <CardMedia
                      component="img"
                      height="250"
                      image={Card6}
                      alt="logo"
                    />
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="div">
                        บริการออกแบบและผลิตโลโก้
                      </Typography>
                      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                        บริการออกแบบและผลิตโลโก้ให้ตรงกับแบรนด์ของคุณ ทั้งแบบเรียบหรู ทันสมัย หรือเป็นมิตร เรายังพิมพ์โลโก้จริงบนสินค้า ด้วยงานสกรีนและรีดร้อน DTF คุณภาพสูง
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>

              <Grid item>
                <Card elevation={3} sx={{ maxWidth: 340, height: '100%', borderRadius: "16px" }}>
                  <CardActionArea>
                    <CardMedia
                      component="img"
                      height="250"
                      image={Card1}
                      alt="Product Mockup"
                    />
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="div">
                        จำลองสินค้าให้เห็นภาพจริง
                      </Typography>
                      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                        เราช่วยออกแบบโลโก้ วางโลโก้บนภาพสินค้า และปรับเปลี่ยนสีสินค้า เพื่อให้คุณเห็นภาพตัวอย่างเสมือนจริง ก่อนตัดสินใจผลิตจริง
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>

              <Grid item>
                <Card elevation={3} sx={{ maxWidth: 340, height: '100%', borderRadius: "16px" }}>
                  <CardActionArea>
                    <CardMedia
                      component="img"
                      height="250"
                      image={Card2}
                      alt="Quality Control"
                    />
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="div">
                        ตรวจสอบคุณภาพทุกขั้นตอน
                      </Typography>
                      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                        เรามุ่งมั่นตรวจสอบคุณภาพในทุกขั้นตอนการผลิต เพื่อให้สินค้าทุกชิ้นมีมาตรฐาน ทั้งด้านวัสดุ การตัดเย็บ และความเรียบร้อยก่อนส่งมอบ
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>

              <Grid item>
                <Card elevation={3} sx={{ maxWidth: 340, height: '100%', borderRadius: "16px" }}>
                  <CardActionArea>
                    <CardMedia
                      component="img"
                      height="250"
                      image={Card3}
                      alt="Delivery"
                    />
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="div"> 
                        จัดส่งสินค้าทั่วประเทศ
                      </Typography>
                      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                        มั่นใจได้ว่าสินค้าทุกชิ้นจะถึงมือคุณอย่างปลอดภัย
                        ตรงเวลาและพร้อมใช้งาน พร้อมบริการจัดส่งทั้งประเทศ
                        เพื่อความสะดวกสูงสุดของคุณ
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>

            </Grid>
          </Grid>

          {/* RIGHT SIDE */}
          <Grid
            item
            xs={12}
            md={4}
            sx={{
              display: { xs: 'none', md: 'block' },
              position: 'sticky',
              top: 20,
              alignSelf: 'flex-start'
            }}
          >
            <FacebookFeed />
          </Grid>

        </Grid>

        

        <Typography component="h1" variant="h5" paddingTop={'15px'} sx={{ mt: 4, fontWeight: 'bold' }}>
        “ลูกค้าชั้นนำ ไว้วางใจ”
        </Typography>
        <Grid container component="main" 
              sx={{ 
                width: '75%',
                paddingTop: '20px',
              }}
        >
          <Box position="relative" sx={{ overflow: 'hidden' }}>
            {/* Fade left */}
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '50px',
                height: '100%',
                zIndex: 1,
                background: 'linear-gradient(to right, white, transparent)',
                pointerEvents: 'none',
              }}
            />
            
            {/* Fade right */}
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                right: 0,
                width: '50px',
                height: '100%',
                zIndex: 1,
                background: 'linear-gradient(to left, white, transparent)',
                pointerEvents: 'none',
              }}
            />

            {/* Carousel */}
            <Box ref={emblaRef2} className="embla" sx={{ overflow: 'hidden' }}>
              <Box className="embla__container" sx={{ display: 'flex', gap: 2 }}>
                {BrandImages.map((image, index) => (
                  <Box
                    className="embla__slide"
                    key={index}
                    sx={{ flex: `0 0 ${isMobile ? "50%" : "30%"}` }}
                  >
                    <Card sx={{ display: "flex", justifyContent: "center", boxShadow: "none" }}>
                      <CardMedia
                        component="img"
                        image={image}
                        alt={`Slide ${index}`}
                        sx={{ height: "100px", objectFit: "contain", borderRadius: "8px" }}
                      />
                    </Card>
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>
        </Grid>


      </Paper>
      <Copyright/>

    </Container>
    </Grid>
    );
}

export default Home;